import { render, staticRenderFns } from "./CandidateRegistration.vue?vue&type=template&id=dae8c4d8&scoped=true"
import script from "./CandidateRegistration.vue?vue&type=script&lang=js"
export * from "./CandidateRegistration.vue?vue&type=script&lang=js"
import style0 from "./CandidateRegistration.vue?vue&type=style&index=0&id=dae8c4d8&prod&scoped=true&lang=css"
import style1 from "./CandidateRegistration.vue?vue&type=style&index=1&id=dae8c4d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae8c4d8",
  null
  
)

export default component.exports